module.exports = "/* Add any custom styles here */\n"